import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService, SupabaseBaseHttpService } from '@examdojo/supabase';

@Injectable({
  providedIn: 'root',
})
export class PayoutAccountHttpService extends SupabaseBaseHttpService<'payout_accounts', 'billing'> {
  constructor(protected override readonly supabase: ExamdojoSupabaseService) {
    super(supabase);
  }

  readonly schema = 'billing';
  readonly tableName = 'payout_accounts';
  override readonly id_field = 'user_id';
}
